export const sportsROCalculator = {
  INDEX: '/sports-ro-calculator',
}
